/* Stendos Horizon: Keep the original Vitals stock urgency widget before the variant options.
   Do not clone the widget; moving its existing node preserves Vitals' own stock text. */
(() => {
  if (window.__stendosVitalsStockPositioner) return;
  window.__stendosVitalsStockPositioner = true;

  const positionStock = () => {
    const section = document.querySelector('#MainContent .product-information');
    const slot = section?.querySelector('[data-stendos-vitals-stock-slot]');
    if (!slot) return;

    const widget =
      section.querySelector('.vtl-su-main-widget') ||
      document.querySelector('#MainContent .vtl-su-main-widget') ||
      document.querySelector('.vtl-su-main-widget');

    if (!widget || slot.contains(widget) || widget.contains(slot)) return;
    slot.appendChild(widget);
  };

  const setup = () => {
    const main = document.querySelector('#MainContent');
    if (!main) return;

    positionStock();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        positionStock();
      });
    });
    observer.observe(main, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
